<template>
    <div class="sidenav-item" :class="{ 'open': isMenuOpen() }">
        <a href="javascript:void(0)" class="sidenav-link sidenav-toggle" :style="[isMenuOpen() ? { 'color': '#e84c64' } : {}]">
            <i class="sidenav-icon fa fa-folder-open"></i>
            <div>
                <slot name="link-text">{{ menuData.title }}</slot>
            </div>
        </a>
        <div class="sidenav-menu">
            <slot name="menu-items">
                <template v-for="child in reports">
                    <ReportMenuItem @favorite_reports_changed="favorite_reports_changed()" :child="child" :show_favorite_button="show_favorite_button" :key="child.title"></ReportMenuItem>
                </template>
            </slot>
        </div>
    </div>
</template>

<script>
import ReportMenuItem from './ReportMenuItem';
import router from '@/router';

export default {
    name: 'ReportMenu',
    data() {
        return {
        };
    },
    components: {
        ReportMenuItem,
    },

    props: {
        reports: {
            type: Array,

        },
        show_favorite_button: {
            type: Boolean,
            default: false
        },
        menuData: {
            type: Object,
            default: () => { }
        }
    },
    methods: {
        favorite_reports_changed() {
            this.$emit('favorite_reports_changed')
        },
        isMenuOpen() {
            let current_page = this.$store.state.page.page.split('/')[2];
            for (let i = 0; i < this.reports.length; i++) {
                if (this.reports[i].name === current_page) {
                    return true
                }
            }
        },
    }
}
</script>
